import { render, staticRenderFns } from "./editModules.vue?vue&type=template&id=31f8b874"
import script from "./editModules.vue?vue&type=script&lang=js"
export * from "./editModules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports